import { Backdrop, CircularProgress } from "@mui/material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useGetSingleByIdTranscationQuery } from "src/services/transcationService";
import TaxInvoice from "./TaxInvoice";

const ReceiptComponent = () => {
  const { id } = useParams();
  const [receiptData, setReceiptData] = useState<any>();
  const { data, isFetching, isLoading } = useGetSingleByIdTranscationQuery(id);

  useEffect(() => {
    if (!isFetching && !isLoading) {
      setReceiptData(data?.data);
    }
  }, [isFetching, isLoading, data]);

  if (isFetching || isLoading) {
    return (
      <Backdrop open={true}>
        <CircularProgress />
      </Backdrop>
    );
  }

  const order = receiptData?.order?.[0] || {};
  const invoiceData = {
    ...order,
    ...receiptData,
    name: order?.name || receiptData?.name,
    email: order?.email || receiptData?.email,
    mobile: order?.mobile || receiptData?.mobile,
    address: order?.address || receiptData?.address,
    city: order?.city || receiptData?.city,
    state: order?.state || receiptData?.state,
    pincode: order?.pincode || receiptData?.pincode,
    courseName: order?.courseName,
    orderTotal: receiptData?.orderTotal || order?.totalFees,
    totalPayable: receiptData?.totalPayable || order?.totalFees,
    products: receiptData?.products?.length
      ? receiptData.products
      : order?.courseName
      ? [
          {
            productName: order.courseName,
            quantity: 1,
            price: Number(order?.totalFees) || 0,
          },
        ]
      : [],
  };

  return (
    <div className="min-h-screen bg-slate-100 py-6 print:bg-white print:py-0">
      <div className="no-print mx-auto mb-3 flex max-w-[860px] justify-end px-4">
        <button
          type="button"
          onClick={() => window.print()}
          className="rounded bg-[#082645] px-4 py-2 text-sm font-medium text-white"
        >
          Print Invoice
        </button>
      </div>
      <TaxInvoice receiptData={invoiceData} />
    </div>
  );
};

export default ReceiptComponent;
